import { z } from 'zod'

export const ADMINORGLISTGET_CONTRACT_VERSION = '1.0.0' as const
export const adminOrgListGetResponseSchema = z.unknown()
export type AdminOrgListGetResponse = z.infer<typeof adminOrgListGetResponseSchema>
